import type { Note, UUID } from "@/core/types";
import { sharedRequestsTyped } from "@/api/(requests)/sharedTyped";

export async function getNotesSummary(patientId: UUID): Promise<Note[]> {
  return sharedRequestsTyped.get_notes_summary({
    context: { showLoader: false },
    urlParams: { patientId },
  });
}
